var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-btn-group"},[_c('div',{staticClass:"toggle-btn"},[_c('div',{staticClass:"switch__container"},[_c('input',{staticClass:"switch switch--shadow",attrs:{"id":_vm.id,"type":"checkbox"},on:{"change":_vm.change}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }